import React from "react";
import { Row, Col, Card, Dropdown } from "react-bootstrap";
import "./ProductsComponent.css"; // Import the CSS file for custom styles
import TitleComponent from "../TitleComponent/TitleComponent";

const ProductsComponent = ({ products, showFilter, title }) => {
  return (
    <div className="products-section p-3 position-relative">
      <div className="header-container d-flex justify-content-between align-items-center">
        <TitleComponent title={title} />

        {/* Conditionally render the dropdown filter */}
        {showFilter && (
          <Dropdown className="dropdown mx-2">
            <Dropdown.Toggle
              className="dropdown-custom-components"
              id="dropdown-custom-components"
            >
              Weekly
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item eventKey="filter1">Weekly</Dropdown.Item>
              <Dropdown.Item eventKey="filter2">Monthly</Dropdown.Item>
              <Dropdown.Item eventKey="filter3">Yearly</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>

      <Row>
        {products.map((product, index) => (
          <Col xs={12} md={4} lg={3} key={index}>
            <Card className="custom-card mt-3">
              <Card.Img
                variant="top"
                src={
                  product.imageUrl ||
                  "https://bagh-e-upload-files-to-s3.s3.eu-west-1.amazonaws.com/profile_image/1731576285400_0753e1c58aec1719e5eef4385983cc79.png"
                } // Use default image if imageUrl is missing
                alt={product.name}
                className="product-image mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://bagh-e-upload-files-to-s3.s3.eu-west-1.amazonaws.com/profile_image/1731576285400_0753e1c58aec1719e5eef4385983cc79.png";
                }} // Fallback to default image on error
              />
              <Card.Body className="pt-2">

                <Card.Title className="text-center">{product.name}</Card.Title>
                { title === "Popular Inputs" &&

                
                <p className="text-center">{product.weight} g</p>
              }
                {/* Conditionally show weight if `showFilter` is true */}
                {showFilter && (
                  <p className="text-center">{product.weight} g</p>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProductsComponent;
